module.exports = __webpack_public_path__ + "img/hso.b02697d6.gif";